import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import {ConfirmationService} from 'primeng/api';

export type TipoIcone = 'atencao' | 'erro' | 'informacao';
@Component({
  selector: 'confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ConfirmPopupComponent implements OnInit {

  @Input() cabecalho: string = 'Confirmação';
  @Input() mensagem: string = 'Tem certeza que deseja continuar';
  @Input() iconeTipo: TipoIcone = 'atencao';
  @Input() legendaConfirmar: string = 'Sim';
  @Input() legendaRejeitar: string = 'Não';
  @Input() legendaCancelar?: string;
  @Input() acaoConfirmar!: () => void;
  @Input() acaoRejeitar?: () => void;

  visivel: boolean = false;

  constructor(
    private cdRef: ChangeDetectorRef
  ) { }

  abrirDialog(): void {
    this.visivel = true;
    this.cdRef.markForCheck();
  }

  cancelar(): void {
    this.visivel = false;
    this.cdRef.markForCheck();
  }

  onConfirmar(): void {
    this.visivel = false;
    if (this.acaoConfirmar) {
      this.acaoConfirmar();
    }
  }

  onRejeitar(): void {
    this.visivel = false;
    if (this.acaoRejeitar) {
      this.acaoRejeitar();
    }
  }

  ngOnInit(): void {
  }
}
